import { render, staticRenderFns } from "./SelectorAccessoriesDisplay.vue?vue&type=template&id=845340ea&scoped=true&"
import script from "./SelectorAccessoriesDisplay.vue?vue&type=script&lang=js&"
export * from "./SelectorAccessoriesDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SelectorAccessoriesDisplay.vue?vue&type=style&index=0&id=845340ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845340ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('845340ea')) {
      api.createRecord('845340ea', component.options)
    } else {
      api.reload('845340ea', component.options)
    }
    module.hot.accept("./SelectorAccessoriesDisplay.vue?vue&type=template&id=845340ea&scoped=true&", function () {
      api.rerender('845340ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/accessories/SelectorAccessoriesDisplay.vue"
export default component.exports